<mat-progress-bar [mode]="mode$ | async" [color]="color" value="100">
</mat-progress-bar>
